import {
  GET_COLLECTIONS_LOADING,
  GET_COLLECTIONS_SUCCESS,
  GET_COLLECTIONS_FAIL,
  SET_COLLECTIONS_LIKE,
  COPY_COLLECTIONS_LOADING,
  COPY_COLLECTIONS_SUCCESS,
  COPY_COLLECTIONS_FAIL,
  INIT_COLLECTIONS,
} from './action_types';
import {
  getPublicCollections,
  createCollectionsFolder,
  deleteCollections,
  deleteCollectionsFolder,
  moveCollectionsToFolder,
  copyCollectionsToFolder,
  getCollectionsFolderList,
  editAliasNameOfCollection,
  updateFolderInfo,
} from '../apis/collections';
import { setLike, socialCopy } from '../apis/social';
import { showRenderToast } from '../components/toast/toast';
import {
  CREATE_COLLECTIONS_FOLDER,
  DELETE_COLLECTIONS,
  MOVE_COLLECTIONS_TO_FOLDER,
  COPY_COLLECTIONS_TO_FOLDER,
  FETCH_COLLECTIONS_FOLDERS,
  UPDATE_ALIAS_NAME_COLLECTION,
  UPDATE_FOLDER_NAME_COLLECTION,
  UPDATE_FOLDER_PUBLIC_STATUS_COLLECTION,
} from '../actionTypes/collection';
import { TYPE_COLLECTION } from '../constants/collections';
import { updatePublicStatus } from '../apis/trips';

const errorToast = message => {
  showRenderToast({ message }, 2000);
};

const handleError = (dispatch, action, errorMessage = '') => {
  dispatch(action);
  errorToast(errorMessage);
};

export const initCollections = () => ({ type: INIT_COLLECTIONS });

export const resetUpdateFolderPublicStatus = () => ({
  type: UPDATE_FOLDER_PUBLIC_STATUS_COLLECTION.INIT,
});

export const fetchCollections = param => dispatch => {
  const { message, folderID, signal } = param;
  dispatch({ type: GET_COLLECTIONS_LOADING });
  getPublicCollections(folderID, signal)
    .then(response => {
      if (response.status !== 200 || response.data.status !== '200') {
        errorToast(message);
        dispatch({ type: GET_COLLECTIONS_FAIL });
      } else {
        dispatch({
          type: GET_COLLECTIONS_SUCCESS,
          payload: response.data.results,
        });
      }
    })
    .catch(error => {
      console.log('fetchCollections Error', error);
      dispatch({ type: GET_COLLECTIONS_FAIL });
    });
};

export const setLikeStatus = params => dispatch => {
  const { userid, id, status, type, message } = params;
  return setLike({ userid, id, status, type })
    .then(response => {
      if (response.status !== 200 || response.data.status !== '200') {
        errorToast(message);
      } else {
        dispatch({
          type: SET_COLLECTIONS_LIKE,
          payload: {
            isLike: response.data.results.is_like,
            likeCount: response.data.results.like_counts,
          },
        });
      }
    })
    .catch(error => {
      console.log('setCollectionsLike Error', error);
    });
};

export const copyCollections = params => dispatch => {
  const { userid, id, name, type } = params;
  dispatch({
    type: COPY_COLLECTIONS_LOADING,
  });
  return socialCopy({ userid, id, name, type })
    .then(response => {
      if (response.status !== 200 || response.data.status !== '200') {
        dispatch({
          type: COPY_COLLECTIONS_FAIL,
        });
      } else {
        dispatch({
          type: COPY_COLLECTIONS_SUCCESS,
        });
      }
    })
    .catch(error => {
      console.log('copyCollections', error);
      dispatch({
        type: COPY_COLLECTIONS_FAIL,
      });
    });
};

export const createFolder = params => async dispatch => {
  const { folderName } = params;
  dispatch({
    type: CREATE_COLLECTIONS_FOLDER.LOADING,
  });

  try {
    const result = await createCollectionsFolder(folderName);
    const { status, results } = result.data;

    if (status !== '200') {
      handleError(dispatch, { type: CREATE_COLLECTIONS_FOLDER.FAIL });

      return 'fail';
    }

    const { _id, publicStatus } = results;
    const payload = { _id, publicStatus, folderName, isFolder: true };

    dispatch({
      type: CREATE_COLLECTIONS_FOLDER.SUCCESS,
      payload,
    });
  } catch (error) {
    handleError(dispatch, { type: CREATE_COLLECTIONS_FOLDER.FAIL });

    return 'fail';
  }

  return 'success';
};

export const deleteCollectionsByIds = params => async dispatch => {
  const { ids, type, folderId } = params;
  dispatch({
    type: DELETE_COLLECTIONS.LOADING,
  });

  try {
    let result = null;

    if (type === TYPE_COLLECTION.FOLDER) {
      result = await deleteCollectionsFolder(ids[0]);
    } else {
      result = await deleteCollections(ids, folderId);
    }
    const { status } = result.data;

    if (status !== '200') {
      handleError(dispatch, { type: DELETE_COLLECTIONS.FAIL });

      return 'fail';
    }

    const payload = { ids, folderId };

    dispatch({
      type: DELETE_COLLECTIONS.SUCCESS,
      payload,
    });
  } catch (error) {
    handleError(dispatch, { type: DELETE_COLLECTIONS.FAIL });

    return 'fail';
  }

  return 'success';
};

export const moveCollectionsToFolderAction = params => async dispatch => {
  const { ids, toFolderId, fromFolderId } = params;
  dispatch({
    type: MOVE_COLLECTIONS_TO_FOLDER.LOADING,
  });

  try {
    const result = await moveCollectionsToFolder(ids, toFolderId, fromFolderId);
    const { status } = result.data;

    if (status !== '200') {
      handleError(dispatch, { type: MOVE_COLLECTIONS_TO_FOLDER.FAIL });

      return 'fail';
    }

    dispatch({
      type: MOVE_COLLECTIONS_TO_FOLDER.SUCCESS,
      payload: params,
    });
  } catch (error) {
    handleError(dispatch, { type: MOVE_COLLECTIONS_TO_FOLDER.FAIL });

    return 'fail';
  }

  return 'success';
};

export const copyCollectionsToFolderAction = params => async dispatch => {
  const { ids, toFolderId, fromFolderId } = params;
  dispatch({
    type: COPY_COLLECTIONS_TO_FOLDER.LOADING,
  });

  try {
    const result = await copyCollectionsToFolder(ids, toFolderId, fromFolderId);
    const { status } = result.data;

    if (status !== '200') {
      handleError(dispatch, { type: COPY_COLLECTIONS_TO_FOLDER.FAIL });

      return 'fail';
    }

    dispatch({
      type: COPY_COLLECTIONS_TO_FOLDER.SUCCESS,
      payload: params,
    });
  } catch (error) {
    handleError(dispatch, { type: COPY_COLLECTIONS_TO_FOLDER.FAIL });

    return 'fail';
  }

  return 'success';
};

export const getFolderItems = params => async dispatch => {
  const { skip, limit } = params;
  dispatch({
    type: FETCH_COLLECTIONS_FOLDERS.LOADING,
    payload: {
      skip,
    },
  });

  try {
    const result = await getCollectionsFolderList(skip, limit);
    const { status } = result.data;

    if (status !== '200') {
      handleError(dispatch, { type: FETCH_COLLECTIONS_FOLDERS.FAIL });

      return 'fail';
    }

    const payload = result.data.results;

    dispatch({
      type: FETCH_COLLECTIONS_FOLDERS.SUCCESS,
      payload,
    });
  } catch (error) {
    handleError(dispatch, { type: FETCH_COLLECTIONS_FOLDERS.FAIL });

    return 'fail';
  }

  return 'success';
};

export const updateAliasNameOfCollection = params => async dispatch => {
  const { id, aliasName, folderId } = params;
  dispatch({
    type: UPDATE_ALIAS_NAME_COLLECTION.LOADING,
    payload: params,
  });

  try {
    const result = await editAliasNameOfCollection(id, aliasName, folderId);
    const { status } = result.data;

    if (status !== '200') {
      handleError(dispatch, { type: UPDATE_ALIAS_NAME_COLLECTION.FAIL });

      return 'fail';
    }

    dispatch({
      type: UPDATE_ALIAS_NAME_COLLECTION.SUCCESS,
      payload: params,
    });
  } catch (error) {
    handleError(dispatch, { type: UPDATE_ALIAS_NAME_COLLECTION.FAIL });

    return 'fail';
  }

  return 'success';
};

export const updateFolderNameOfCollection = params => async dispatch => {
  const { folderName, folderId } = params;
  dispatch({
    type: UPDATE_FOLDER_NAME_COLLECTION.LOADING,
    payload: params,
  });

  try {
    const result = await updateFolderInfo(folderId, folderName);
    const { status } = result.data;

    if (status !== '200') {
      handleError(dispatch, { type: UPDATE_FOLDER_NAME_COLLECTION.FAIL });

      return 'fail';
    }

    dispatch({
      type: UPDATE_FOLDER_NAME_COLLECTION.SUCCESS,
      payload: params,
    });
  } catch (error) {
    handleError(dispatch, { type: UPDATE_FOLDER_NAME_COLLECTION.FAIL });

    return 'fail';
  }

  return 'success';
};

export const updateFolderPublicStatusOfCollection = params => async dispatch => {
  const { publicStatus, folderId } = params;
  dispatch({
    type: UPDATE_FOLDER_PUBLIC_STATUS_COLLECTION.LOADING,
    payload: params,
  });

  try {
    const result = await updatePublicStatus(folderId, publicStatus, 4);
    const { status } = result.data;

    if (status !== '200') {
      handleError(dispatch, {
        type: UPDATE_FOLDER_PUBLIC_STATUS_COLLECTION.FAIL,
      });

      return 'fail';
    }

    dispatch({
      type: UPDATE_FOLDER_PUBLIC_STATUS_COLLECTION.SUCCESS,
      payload: params,
    });
  } catch (error) {
    handleError(dispatch, {
      type: UPDATE_FOLDER_PUBLIC_STATUS_COLLECTION.FAIL,
    });

    return 'fail';
  }

  return 'success';
};
